<template>
    <div></div>
</template>
<script>
    export default {
        data () {
            return {
                resources: null,
                query: '',
                paginator: {
                    filter: '',
                    sort: '',
                    order: '',
                    page: 1,
                    last: 1,
                    total: 1,
                    listing: ''
                }
            }
        },
        mounted: function(){
            this.refresh()
        },
        methods: {
            edit: function(id, route){
                let name = this.$route.name + '-edit'
                    //name = route ? route : name
                this.$router.push({ name: name, params: {id: id}});
            },
            remove: function(id){
                let ask = confirm("Etes-vous certain de vouloir supprimer cet élément ?");
                if( ask && this.getResource() ){
                    this.getResource().api.delete(id).then((response) => {
                        this.refresh()
                    })
                }
            },
            importFile: function(){
                this.$router.push({ name: this.$route.name + '-import'});
            },
            exportFile: function(){
                this.getResource().api.export().then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'export.xlsx'); //or any other extension
                    document.body.appendChild(link);
                    link.click();
                })
                //this.$router.push({ name: this.$route.name + '-export'});
            },
            create: function(){
                this.$router.push({ name: this.$route.name + '-new'});
            },
            resourceLoaded: function(){

            },
            refresh: function(force){
                if( force ){ this.paginator.page = 1; }

                if( this.getResource() ){

                    this.getResource().api.query(
                        '?query=' + this.query +
                        '&page=' + this.paginator.page +
                        '&order=' + this.paginator.order +
                        '&sort=' + this.paginator.sort +
                        '&filter=' + this.paginator.filter
                    ).then((response) => {
                        this.resources = response.data.data
                        this.paginator.last = response.data.last_page
                        this.paginator.total = response.data.total

                        var field = this.paginator.sort ? this.paginator.sort : null

                        setTimeout(function(){
                            if( field ){
                                var els = document.querySelectorAll("[data-field]");
                                for (var i = 0, len = els.length; i < len; i++) {
                                    els[i].className = els[i].className.replace(" active", "");
                                    if( els[i].getAttribute("data-field") == field){
                                        els[i].className += " active";
                                    }
                                }
                            }
                        }, 1)
                        this.resourceLoaded();
                    })

                }
            },
            setOrder: function(e){
                var field = e.target.getAttribute('data-sort');
                this.paginator.order = this.paginator.sort == field ? this.paginator.order == 'asc' ? 'desc' : 'asc' : 'asc';
                this.paginator.sort = field;
                this.paginator.page = 1;
                this.refresh();
            },
            setFilter: function(field){
                this.paginator.filter = field;
                this.paginator.page = 1;
                this.refresh();
            }
        },
        watch: {
            '$store.getters.scope'(newId, oldId) {
                this.refresh(true);
            },
            'query'(newVal, oldVal) {
                this.refresh(true)
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/layouts/Index.vue